const doc = [({"zh_cn":({"adminConstantHotelPriceUpdateType":({"absolute":"设定价格", "relative":"调整原价"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;